import { useContext } from "react";
import HeaderContext from "../contexts/HeaderContext";

export default function useHeader() {
  const { header, setHeader } = useContext(HeaderContext);

  return { header, setHeader };
}
